import { createActions } from 'redux-actions';
import { getActionOptions } from 'src/lib/reduxActionsUtils';
import { ACTION_PREFIX, actionTypes } from './constants';

export const { addCount, subtractCount } = createActions(actionTypes.ADD_COUNT, actionTypes.SUBTRACT_COUNT, getActionOptions(ACTION_PREFIX));
export default {
  addCount,
  subtractCount,
};
